import { atom } from "recoil"

/**
 * Tracks whether the MonthlyBillSlide component is fully rendered and ready for PDF generation.
 * This ensures the dial component, bill values, and all animations are complete before the PDF is generated.
 *
 * The component reports ready when:
 * - The dial size is available (from useSize hook)
 * - The handle position is set
 * - Savings data is available and not currently syncing
 * - Brochure data (bill values) is fully loaded
 */
export const monthlyBillSlideReadyState = atom<boolean>({
  key: `monthlyBillSlideReadyState`,
  default: false,
})
